import { Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useCommandBarContext } from "../../context/command-bar/CommandBarContext";
import { modKeyLabel } from "../../utils/shortcut-label";
import "./HeaderCommandBar.scss";

/**
 * A search-looking trigger that opens the app-wide command palette overlay
 * (CommandPalette). The palette itself is the single command UI — this is just
 * the visible, clickable entry point in a page header. Cmd/Ctrl-K opens the same
 * palette from anywhere.
 */
export function HeaderCommandBar() {
  const { open } = useCommandBarContext();

  return (
    <Box className="header-command-bar">
      <button
        type="button"
        className="header-command-trigger"
        onClick={open}
        title={`Search or run command (${modKeyLabel("K")})`}
        aria-label="Search or run command"
      >
        <SearchIcon fontSize="small" className="header-command-trigger-icon" />
        <span className="header-command-trigger-kbd">{modKeyLabel("K")}</span>
      </button>
    </Box>
  );
}
